import { Controller } from 'stimulus'

export default class extends Controller {
  static values = { autoload: Boolean }

  connect() {
    this.element[this.identifier] = this
    this.grecaptchaKey = '6LdberoUAAAAAAIYHgkXVFiMgJkgN5Vu-WWLPzVZ'
    this.grecaptchaId = this.element.dataset.grecaptchaId
    this.element.classList.add('transform', 'scale-75', 'sm:scale-100', 'origin-top-left')
    this.reset()
    if (this.autoloadValue) this.init()
  }

  init() {
    if (!this.grecaptchaIncluded()) return

    grecaptcha.ready(() => this.render())
  }

  reset() {
    if (!this.grecaptchaRendered()) return

    grecaptcha.reset(this.grecaptchaId)
  }

  render() {
    const grecaptchaId = grecaptcha.render(this.element, { sitekey: this.grecaptchaKey })
    this.element.dataset.grecaptchaId = grecaptchaId
  }

  grecaptchaIncluded() { return typeof grecaptcha !== 'undefined' }
  grecaptchaRendered() { return typeof this.grecaptchaId !== 'undefined' }
}
